module.exports = __webpack_public_path__ + "img/sql.6ef05af6.png";